// Rolls each data-item__number from 0 to its value the first time it enters
// the top 95% of the viewport. Detects the leading number inside the text
// (e.g. "3,464L" -> rolls "3,464", keeps "L" static) and skips items that
// contain no digits at all.
const DATA_ITEM_NUMBER_SELECTOR = '.data-item__number';
const DATA_ITEM_GROUP_SELECTOR = '.data-section__list, .dataset';
const NUMBER_TOKEN_PATTERN = /\d[\d.,]*/;
const ROLL_DURATION_MS = 1200;
const ITEM_STAGGER_MS = 150;
const ROWS_PER_DIGIT = 11; // 1 logo row + digits 0-9

function easeOutCubic(t) {
  return 1 - (1 - t) ** 3;
}

function buildRoller(numberEl) {
  const originalText = numberEl.textContent.trim();
  const match = originalText.match(NUMBER_TOKEN_PATTERN);
  if (!match) return null;

  const prefix = originalText.slice(0, match.index);
  const token = match[0];
  const suffix = originalText.slice(match.index + token.length);

  const logoTemplate = numberEl.querySelector('template.data-item__logo-template');
  const logoMarkup = logoTemplate ? logoTemplate.innerHTML : '';

  const visual = document.createElement('span');
  visual.className = 'data-item__number-visual';
  visual.setAttribute('aria-hidden', 'true');

  if (prefix) visual.append(document.createTextNode(prefix));

  const digitTracks = [];
  Array.from(token).forEach((char) => {
    if (/\d/.test(char)) {
      const target = Number(char);
      const digit = document.createElement('span');
      digit.className = 'data-item__digit';

      const track = document.createElement('span');
      track.className = 'data-item__digit-track';

      const logoRow = document.createElement('span');
      logoRow.className = 'data-item__digit-row data-item__digit-row--logo';
      logoRow.style.opacity = '1';
      logoRow.innerHTML = logoMarkup;
      track.append(logoRow);

      for (let row = 0; row <= 9; row += 1) {
        const rowEl = document.createElement('span');
        rowEl.className = 'data-item__digit-row';
        rowEl.textContent = String(row);
        rowEl.style.opacity = String(Math.max(0.1, 1 - Math.abs(row - target) * 0.2));
        track.append(rowEl);
      }

      digit.append(track);
      visual.append(digit);
      digitTracks.push({ track, target });
    } else {
      const separator = document.createElement('span');
      separator.className = 'data-item__digit-separator';
      separator.textContent = char;
      visual.append(separator);
    }
  });

  if (suffix) visual.append(document.createTextNode(suffix));

  const srOnly = document.createElement('span');
  srOnly.className = 'sr-only';
  srOnly.textContent = originalText;

  numberEl.textContent = '';
  numberEl.append(visual, srOnly);

  return { digitTracks, visual };
}

function rollDigits(digitTracks) {
  const startTime = performance.now();

  function tick(now) {
    const elapsed = now - startTime;
    const t = Math.min(elapsed / ROLL_DURATION_MS, 1);
    const eased = easeOutCubic(t);

    digitTracks.forEach(({ track, target }) => {
      const position = eased * (target + 1);
      track.style.transform = `translateY(${-position * (100 / ROWS_PER_DIGIT)}%)`;
    });

    if (t < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}

function assignGroupOrder(numberEls) {
  const groupCounts = new Map();

  numberEls.forEach((numberEl) => {
    const group = numberEl.closest(DATA_ITEM_GROUP_SELECTOR) || document.body;
    const order = groupCounts.get(group) || 0;
    numberEl.dataset.rollOrder = String(order);
    groupCounts.set(group, order + 1);
  });
}

function initDataItemRollers(root = document) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const numberEls = Array.from(root.querySelectorAll(DATA_ITEM_NUMBER_SELECTOR)).filter(
    (el) => !el.dataset.rollReady
  );
  if (numberEls.length === 0) return;

  const rollers = new Map();
  numberEls.forEach((numberEl) => {
    const roller = buildRoller(numberEl);
    if (!roller) return;
    numberEl.dataset.rollReady = 'true';
    rollers.set(numberEl, roller);
  });
  if (rollers.size === 0) return;

  assignGroupOrder(Array.from(rollers.keys()));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);

        const { digitTracks, visual } = rollers.get(entry.target);
        const order = Number(entry.target.dataset.rollOrder || 0);
        setTimeout(() => {
          visual.style.opacity = '1';
          rollDigits(digitTracks);
        }, order * ITEM_STAGGER_MS);
      });
    },
    { threshold: 1, rootMargin: '0px 0px -5% 0px' }
  );

  rollers.forEach((_roller, numberEl) => observer.observe(numberEl));
}

window.addEventListener('DOMContentLoaded', () => initDataItemRollers());

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initDataItemRollers(event.target));
}
